import { Card, Progress, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import type { FC } from 'react';

import { FormStepId } from 'shared/config/formStepId';
import { DotLottieReactLoader } from 'shared/ui/DotLottieReactLoader';

import { useStepper } from 'widgets/AnketaWidget/lib';

import { CREDIT_CARD_FORM_PROGRESS_CONFIG } from '../CreditCardFormProgress.config';
import { CreditCardFormProgressTexts } from '../CreditCardFormProgress.texts';

import styles from './CreditCardFormProgress.module.scss';

type Props = {
  className?: string;
};

export const CreditCardFormProgress: FC<Props> = (props) => {
  const { className } = props;
  const isMobile = useIsMobile();
  const { activeStep } = useStepper();
  const step = activeStep?.formId || FormStepId.CreditPurposeInfo;

  const stepConfig = CREDIT_CARD_FORM_PROGRESS_CONFIG[step];

  const percentString = `+${stepConfig.percent}% к точности за ${stepConfig.stepLabel} шаг`;

  return (
    <Card
      className={cn(styles.formProgressCard, className)}
      size={isMobile ? 16 : 24}
    >
      <Space
        direction="vertical"
        size={4}
      >
        <Typography.Text
          size={isMobile ? 12 : 14}
          className="h-color-D60"
        >
          {CreditCardFormProgressTexts.Title}
        </Typography.Text>
        <Space
          direction="vertical"
          size={4}
        >
          <Typography.Heading level={3}>{stepConfig.accuracy}</Typography.Heading>
          <Progress
            height={isMobile ? 4 : 2}
            percent={stepConfig.percent}
          />
          <Typography.Text
            size={isMobile ? 12 : 14}
            className="h-color-D60"
          >
            {percentString}
          </Typography.Text>
        </Space>
        {!isMobile && (
          <DotLottieReactLoader
            src={stepConfig.src}
            autoplay={step !== FormStepId.CreditPurposeInfo}
            height={130}
            className={cn('h-pt-12', 'h-pb-12')}
          />
        )}
      </Space>
    </Card>
  );
};
